import { Button, message, Tooltip } from "antd";
import React, { useRef } from "react";
import { BsPersonBadgeFill } from "react-icons/bs";
import { connect, useDispatch } from "react-redux";
import { initNewLayer } from "../../../Utilities/helper";

import { pick } from "lodash";
import { ARTWORK } from "../../../../../types";

import CreateFile from "../../../../upload/CreateFile";

const AddToy3dLayer = (props) => {
    const { layers } = props;
    const dispatch = useDispatch();

    const addImageToy3d = (file) => {
        const newImageLayer = initNewLayer();
        newImageLayer.type = "Image";
        newImageLayer.values[0].file = pick(file, ["id", "key"]);
        newImageLayer.imageToy3d = true;
        newImageLayer.personalized = {
            enable: true
        };
        newImageLayer.title = `3D Toy Style #${
            layers.filter((l) => l.imageToy3d).length + 1
        }`;
        dispatch({
            type: ARTWORK.ADD_LAYER,
            payload: newImageLayer,
        });
    };
    return (
        <Tooltip title="Add 3D Toy Style">
            <CreateFile
                accept=".jpg, .png, .jpeg"
                onChange={addImageToy3d}
            >
                <Button
                    style={{
                        width: "100%",
                        borderRadius: 0,
                        borderLeftWidth: 0,
                        padding: 0,
                    }}
                    icon={<BsPersonBadgeFill className="anticon" />}
                ></Button>
            </CreateFile>
        </Tooltip>
    );
};

export default connect((state) => ({
    workspace: state.artwork.workspace,
}))(AddToy3dLayer);